import {
  Box,
  Container,
  Fade,
  Grid,
  Grow,
  Paper,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { HiOutlineCalendar } from "react-icons/hi";

import Header from "../Header";

import bg_image from "../../assets/background/publication_bg.jpg";

import useContent from "../../hooks/useContent";
import useInView from "../../hooks/useInView";
import { theme } from "../../utils/theme";

import { styles } from "./style";

const HEADER_HEIGHT = { xs: 240, sm: 360 };

const Publications = () => {
  const content = useContent();
  const [setRef, visible] = useInView({
    threshold: 0.1,
  });

  const [mouseOver, setMouseOver] = useState(null);

  const handleOnClickNavigateProject = (link) => (event) => {
    window.open(link, "_blank");
  };

  return (
    <Box>
      <Box
        sx={{
          alignItems: "center",
          background: `url(${bg_image})`,
          backgroundColor: theme.palette.primary.dark,
          backgroundPosition: "center !important",
          backgroundRepeat: "no-repeat !important",
          backgroundSize: "cover !important",
          display: "flex",
          backdropFilter: "brightness(0.6) opacity(1)",
          height: HEADER_HEIGHT,
          justifyContent: "center",
          left: { xs: 0, sm: 0 },
          top: 0,
          width: "100%    ",
          zIndex: 1,
        }}
      >
        <Container maxWidth="lg">
          <Fade in={visible} timeout={500}>
            <Stack spacing={4} sx={{ pt: 8 }}>
              <Header
                center={false}
                data={content.publications}
                headerRef={setRef}
                style={{ color: theme.palette.grays.white }}
              />

              <Typography sx={styles.bodyText}>
                {content.publications.body}
              </Typography>
            </Stack>
          </Fade>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ pb: 18, pt: 8 }}>
        <Grid
          container
          direction={"row"}
          ref={setRef}
          spacing={0}
          sx={styles.body}
        >
          <Grid item xs={12} sm={12} md={12}>
            {content.publications.items.map((item, index) => {
              return (
                <Box key={index} sx={styles.section}>
                  <Box sx={styles.sectionHeader}>
                    <HiOutlineCalendar
                      size={"0.8em"}
                      style={{
                        color: theme.palette.primary.main,
                        marginRight: 8,
                      }}
                    />
                    {item.year}
                  </Box>

                  {item.items.map((ele, idx) => {
                    return (
                      <Grow in={visible} timeout={1000 + idx * 500}>
                        <Paper
                          key={idx}
                          onClick={handleOnClickNavigateProject(ele.link)}
                          onMouseEnter={() => setMouseOver(ele.header)}
                          onMouseLeave={() => setMouseOver(null)}
                          sx={styles.item}
                        >
                          <Typography sx={styles.itemSubheader}>
                            {ele.subHeader}
                          </Typography>

                          <Typography
                            sx={styles.itemHeader}
                            style={{
                              textDecoration:
                                mouseOver === ele.header ? "underline" : "none",
                            }}
                          >
                            {ele.header}
                          </Typography>

                          <Typography sx={styles.itemText}>
                            {ele.authors}
                          </Typography>

                          {/* <Box
                        sx={styles.itemAction}
                        // onClick={handleOnClickNavigateProject(ele.link)}
                        // onMouseEnter={() => setMouseOver(idx)}
                        // onMouseLeave={() => setMouseOver(null)}
                      >
                        {ele.action}

                        <HiArrowLongRight
                          size={"1.4em"}
                          style={{
                            transform:
                              mouseOver === idx
                                ? "translateX(8px)"
                                : "translateX(2px)",
                            transition: "all 0.3s ease-in-out",
                          }}
                        />
                      </Box> */}
                        </Paper>
                      </Grow>
                    );
                  })}
                </Box>
              );
            })}
          </Grid>
        </Grid>
      </Container>

      <Box sx={styles.background} />
    </Box>
  );
};

export default Publications;
